import Enumeration from '../utils/enum-util'

export const inputs = new Enumeration(({
  title: 'title',
  description: 'description',
  terms: 'terms'
}))
